<template>
  <modal-dialog ref="modal" :title="title">
    <alert-box
      v-for="alert in alerts"
      :key="alert.message"
      :type="alert.type"
    >
      {{ alert.message }}
    </alert-box>
    <div v-if="variant" class="row">
      <div class="col-xs-12 col-md-6">
        <div class="card">
          <img :src="variant.product_image_url" :alt="variant.name" class="card-img-top" />
          <div class="card-body">
            <h6 class="card-title">{{ variant.name }}</h6>
          </div>
        </div>
      </div>
      <add-to-cart-modal-summary
        class="col-xs-12 col-md-6"
        :heading="cartHeading"
        :total-label="totalLabel"
        :order="order"
      />
    </div>
    <div v-else class="row">
      <add-to-cart-modal-summary
        class="col-xs-12"
        :heading="cartHeading"
        :total-label="totalLabel"
        :order="order"
      />
    </div>

    <template v-slot:footer>
      <button
        type="button"
        class="btn btn-secondary"
        @click.prevent="close"
      >
        {{ continueShoppingLabel }}
      </button>
      <a href="/cart" class="btn btn-primary">{{ viewCartLabel }}</a>
    </template>
  </modal-dialog>
</template>

<script>
  import ModalDialog from '../modal-dialog.vue'
  import AlertBox from '../alert-box.vue'
  import AddToCartModalSummary from './modal-summary.vue'

  export default {
    components: {
      ModalDialog,
      AlertBox,
      AddToCartModalSummary
    },
    props: {
      variant: { type: Object, required: false, default: () => {} },
      order: { type: Object, required: true },
      warnings: { type: Array, default: () => [] },
      title: { type: String, default: 'Added to Cart ✔' },
      cartHeading: { type: String, default: 'Cart info' },
      totalLabel: { type: String, default: 'Order Subtotal' },
      continueShoppingLabel: { type: String, default: 'Continue shopping' },
      viewCartLabel: { type: String, default: 'View Cart' }
    },
    computed: {
      alerts() {
        return this.warnings.map((warning) => {
          return {
            message: warning,
            type: 'warning'
          }
        })
      }
    },
    methods: {
      open() {
        this.$refs.modal.open()
      },
      close() {
        this.$refs.modal.close()
      }
    }
  }
</script>
